<script>
  export let records = [];
  export let stats = {};

  // Calculate additional metrics
  $: additionalStats = (() => {
    if (!records || records.length === 0) {
      return {
        totalDays: 0,
        averagePerDay: 0,
        maxWeight: 0,
        minWeight: 0,
        mostActiveDay: '',
        mostActiveDayWeight: 0
      };
    }

    // Group by date
    const dailyTotals = {};
    records.forEach(record => {
      const recordDate = new Date(record.fecha);
      // Convert from UTC to Guatemala timezone (UTC-6)
      const guatemalaDate = new Date(recordDate.getTime() - (6 * 60 * 60 * 1000));
      const day = String(guatemalaDate.getUTCDate()).padStart(2, '0');
      const month = String(guatemalaDate.getUTCMonth() + 1).padStart(2, '0');
      const year = guatemalaDate.getUTCFullYear();
      const date = `${day}/${month}/${year}`;
      dailyTotals[date] = (dailyTotals[date] || 0) + (record.total_peso || 0);
    });

    const totalDays = Object.keys(dailyTotals).length;
    const averagePerDay = totalDays > 0 ? stats.totalPeso / totalDays : 0;
    
    const weights = records.map(r => r.total_peso || 0);
    const maxWeight = Math.max(...weights);
    const minWeight = Math.min(...weights);

    // Find most active day
    const mostActiveDay = Object.entries(dailyTotals)
      .sort(([,a], [,b]) => b - a)[0];
    const mostActiveDayWeight = mostActiveDay ? mostActiveDay[1] : 0;
    const mostActiveDayDate = mostActiveDay ? mostActiveDay[0] : '';

    return {
      totalDays,
      averagePerDay: Math.round(averagePerDay * 100) / 100,
      maxWeight,
      minWeight,
      mostActiveDay: mostActiveDayDate,
      mostActiveDayWeight
    };
  })();
</script>

<div class="relative flex flex-col min-w-0 break-words bg-white w-full mb-6 shadow-lg rounded">
  <div class="rounded-t mb-0 px-4 py-3 border-0">
    <div class="flex flex-wrap items-center">
      <div class="relative w-full px-4 max-w-full flex-grow flex-1">
        <h3 class="font-semibold text-base text-blueGray-700">
          Resumen de Actividad
        </h3>
      </div>
    </div>
  </div>
  <div class="block w-full overflow-x-auto p-4">
    <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
      <!-- Total Days -->
      <div class="bg-blue-50 p-4 rounded-lg">
        <div class="flex items-center">
          <div class="p-2 bg-red-500 rounded-full">
            <i class="fas fa-calendar text-white text-sm"></i>
          </div>
          <div class="ml-3">
            <p class="text-sm font-medium text-blue-600">Días Activos</p>
            <p class="text-lg font-semibold text-blue-900">{additionalStats.totalDays}</p>
          </div>
        </div>
      </div>

      <!-- Average Per Day -->
      <div class="bg-green-50 p-4 rounded-lg">
        <div class="flex items-center">
          <div class="p-2 bg-red-500 rounded-full">
            <i class="fas fa-chart-line text-white text-sm"></i>
          </div>
          <div class="ml-3">
            <p class="text-sm font-medium text-green-600">Promedio Diario</p>
            <p class="text-lg font-semibold text-green-900">{additionalStats.averagePerDay} lbs</p>
          </div>
        </div>
      </div>

      <!-- Max Weight -->
      <div class="bg-purple-50 p-4 rounded-lg">
        <div class="flex items-center">
          <div class="p-2 bg-purple-500 rounded-full">
            <i class="fas fa-arrow-up text-white text-sm"></i>
          </div>
          <div class="ml-3">
            <p class="text-sm font-medium text-purple-600">Peso Máximo</p>
            <p class="text-lg font-semibold text-purple-900">{additionalStats.maxWeight.toLocaleString()} lbs</p>
          </div>
        </div>
      </div>

      <!-- Min Weight -->
      <div class="bg-orange-50 p-4 rounded-lg">
        <div class="flex items-center">
          <div class="p-2 bg-orange-500 rounded-full">
            <i class="fas fa-arrow-down text-white text-sm"></i>
          </div>
          <div class="ml-3">
            <p class="text-sm font-medium text-orange-600">Peso Mínimo</p>
            <p class="text-lg font-semibold text-orange-900">{additionalStats.minWeight.toLocaleString()} lbs</p>
          </div>
        </div>
      </div>

      <!-- Most Active Day -->
      <div class="bg-red-50 p-4 rounded-lg">
        <div class="flex items-center">
          <div class="p-2 bg-red-500 rounded-full">
            <i class="fas fa-star text-white text-sm"></i>
          </div>
          <div class="ml-3">
            <p class="text-sm font-medium text-red-600">Día Más Activo</p>
            <p class="text-lg font-semibold text-red-900">{additionalStats.mostActiveDay}</p>
            <p class="text-xs text-red-600">{additionalStats.mostActiveDayWeight.toLocaleString()} lbs</p>
          </div>
        </div>
      </div>

      <!-- Efficiency -->
      <div class="bg-indigo-50 p-4 rounded-lg">
        <div class="flex items-center">
          <div class="p-2 bg-indigo-500 rounded-full">
            <i class="fas fa-percentage text-white text-sm"></i>
          </div>
          <div class="ml-3">
            <p class="text-sm font-medium text-indigo-600">Eficiencia</p>
            <p class="text-lg font-semibold text-indigo-900">
              {stats.totalPilotos > 0 ? Math.round((stats.totalPeso / stats.totalPilotos) * 100) / 100 : 0} lbs/piloto
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</div> 